export default __webpack_public_path__ + "static/media/bpay-color.624e6e32.svg";